import { ActionReducerMap } from '@ngrx/store';
import * as fromUser from './user';
import * as fromCurrentUser from './currentUser';
import * as fromCurrentFarm from './currentFarm';
import * as fromFarm from './farm';
import * as fromCompany from './company';
import * as fromCommodity from './commodity';
import * as fromContainer from './container';
import * as fromContainerActivity from './containerActivity';
import * as fromCrop from './crop';
import * as fromDevice from './device';
import * as fromDeviceData from './deviceData';
import * as fromEquipment from './equipment';
import * as fromEquipmentActivity from './equipmentActivity';
import * as fromField from './field';
import * as fromFieldActivity from './fieldActivity';
import * as fromFieldGroup from './fieldGroup';
import * as fromLandRegistry from './landRegistry';
import * as fromLoad from './load';
import * as fromNote from './note';
import * as fromParcel from './parcel';
import * as fromProduct from './product';
import * as fromPayment from './payment';
import * as fromPlant from './plant';
import * as fromStoreModel from './storeModel';
import * as fromSupplier from './supplier';
import * as fromWarehouse from './warehouse';
import * as fromNotification from './notification';
import * as fromAlertGroup from './alertGroup';
import * as fromCompanyAddress from './companyAddress';
import * as fromCompanyContact from './companyContact';
import * as fromEmployee from './employee';
import * as fromCertificationDoc from './certificationDoc';
import * as fromEmployeeDoc from './employeeDoc';
import * as fromInsuranceDoc from './insuranceDoc';
import * as fromInvoiceDoc from './invoiceDoc';
import * as fromSecurityDoc from './securityDoc';
import * as fromCostGenericDoc from './costGenericDoc';
import * as fromTag from './tag';
import * as fromUserGroup from './userGroup';
import * as fromCustomer from './customer';
import * as fromCertification from './certification';
import * as fromInsurance from './insurance';
import * as fromSecurity from './security';
import * as fromMachineActivity from './machineActivity';
import * as fromPersonAddress from './personAddress';
import * as fromPersonContact from './personContact';
import * as fromFarmCadastralSheet from './farmCadastralSheet';
import * as fromMessage from './message';
import * as fromIrrigationAdvice from './irrigationAdvice';
import * as fromXidro from './xidroDevices';
import * as fromFarmWeatherLocation from './farmWeatherLocation';

export interface AppState {
  users: fromUser.UserState;
  currentUser: fromCurrentUser.CurrentUserState;
  currentFarm: fromCurrentFarm.CurrentFarmState;
  farms: fromFarm.FarmState;
  companies: fromCompany.CompanyState;
  commodities: fromCommodity.CommodityState;
  containers: fromContainer.ContainerState;
  containerActivities: fromContainerActivity.ContainerActivityState;
  crops: fromCrop.CropState;
  devices: fromDevice.DeviceState;
  devicesData: fromDeviceData.DeviceDataState;
  equipments: fromEquipment.EquipmentState;
  equipmentActivities: fromEquipmentActivity.EquipmentActivityState;
  farmWeatherLocations: fromFarmWeatherLocation.FarmWeatherLocationState;
  fields: fromField.FieldState;
  fieldActivities: fromFieldActivity.FieldActivityState;
  fieldGroups: fromFieldGroup.FieldGroupState;
  landRegistries: fromLandRegistry.LandRegistryState;
  loads: fromLoad.LoadState;
  notes: fromNote.NoteState;
  parcels: fromParcel.ParcelState;
  products: fromProduct.ProductState;
  payments: fromPayment.PaymentState;
  plants: fromPlant.PlantState;
  storeModels: fromStoreModel.StoreModelState;
  suppliers: fromSupplier.SupplierState;
  warehouses: fromWarehouse.WarehouseState;
  notifications: fromNotification.NotificationState;
  alertGroups: fromAlertGroup.AlertGroupState;
  companyAddresses: fromCompanyAddress.CompanyAddressState;
  companyContacts: fromCompanyContact.CompanyContactState;
  employees: fromEmployee.EmployeeState;
  employeesDocs: fromEmployeeDoc.EmployeeDocState;
  certificationDocs: fromCertificationDoc.CertificationDocState;
  insuranceDocs: fromInsuranceDoc.InsuranceDocState;
  invoiceDocs: fromInvoiceDoc.InvoiceDocState;
  securityDocs: fromSecurityDoc.SecurityDocState;
  costGenericDocs: fromCostGenericDoc.CostGenericDocState;
  tags: fromTag.TagState;
  userGroups: fromUserGroup.UserGroupState;
  customers: fromCustomer.CustomerState;
  certifications: fromCertification.CertificationState;
  insurances: fromInsurance.InsuranceState;
  securities: fromSecurity.SecurityState;
  machineActivities: fromMachineActivity.MachineActivityState;
  personAddresses: fromPersonAddress.PersonAddressState;
  personContacts: fromPersonContact.PersonContactState;
  farmCadastralSheets: fromFarmCadastralSheet.FarmCadastralSheetState;
  messages: fromMessage.MessageState;
  irrigationAdvice: fromIrrigationAdvice.IrrigationAdviceState;
  xidroDevices: fromXidro.XidroState;
}

export const reducers: ActionReducerMap<AppState> = {
  users: fromUser.reducer,
  currentUser: fromCurrentUser.reducer,
  currentFarm: fromCurrentFarm.reducer,
  farms: fromFarm.reducer,
  companies: fromCompany.reducer,
  commodities: fromCommodity.reducer,
  containers: fromContainer.reducer,
  containerActivities: fromContainerActivity.reducer,
  crops: fromCrop.reducer,
  devices: fromDevice.reducer,
  devicesData: fromDeviceData.reducer,
  equipments: fromEquipment.reducer,
  equipmentActivities: fromEquipmentActivity.reducer,
  farmWeatherLocations: fromFarmWeatherLocation.reducer,
  fields: fromField.reducer,
  fieldActivities: fromFieldActivity.reducer,
  fieldGroups: fromFieldGroup.reducer,
  landRegistries: fromLandRegistry.reducer,
  loads: fromLoad.reducer,
  notes: fromNote.reducer,
  parcels: fromParcel.reducer,
  products: fromProduct.reducer,
  payments: fromPayment.reducer,
  plants: fromPlant.reducer,
  storeModels: fromStoreModel.reducer,
  suppliers: fromSupplier.reducer,
  warehouses: fromWarehouse.reducer,
  notifications: fromNotification.reducer,
  alertGroups: fromAlertGroup.reducer,
  companyAddresses: fromCompanyAddress.reducer,
  companyContacts: fromCompanyContact.reducer,
  employees: fromEmployee.reducer,
  employeesDocs: fromEmployeeDoc.reducer,
  certificationDocs: fromCertificationDoc.reducer,
  insuranceDocs: fromInsuranceDoc.reducer,
  invoiceDocs: fromInvoiceDoc.reducer,
  securityDocs: fromSecurityDoc.reducer,
  costGenericDocs: fromCostGenericDoc.reducer,
  tags: fromTag.reducer,
  userGroups: fromUserGroup.reducer,
  customers: fromCustomer.reducer,
  certifications: fromCertification.reducer,
  insurances: fromInsurance.reducer,
  securities: fromSecurity.reducer,
  machineActivities: fromMachineActivity.reducer,
  personAddresses: fromPersonAddress.reducer,
  personContacts: fromPersonContact.reducer,
  farmCadastralSheets: fromFarmCadastralSheet.reducer,
  messages: fromMessage.reducer,
  irrigationAdvice: fromIrrigationAdvice.reducer,
  xidroDevices: fromXidro.xidroReducer,
};
